import React from 'react';
import { ProgressBar } from 'react-bootstrap';

const steps = [
  { number: 1, label: 'Guest Details' },
  { number: 2, label: 'Payment' },
];

const BookingProgress = ({ currentStep }) => {
  const progress = (currentStep / steps.length) * 100;

  return (
    <div className="hb-progress-container-booking mb-4">
      <ProgressBar
        now={progress}
        className="hb-progress-bar-booking"
        style={{ height: '8px', borderRadius: '4px' }}
      />

      <div className="d-flex justify-content-between mt-3">
        {steps.map((step) => {
          const isActive  = currentStep >= step.number;
          const isCurrent = currentStep === step.number;
          const isDone    = currentStep > step.number;

          return (
            <div
              key={step.number}
              className={`hb-step-booking text-center ${isActive ? 'hb-step-active-booking' : ''} ${isCurrent ? 'hb-step-current-booking' : ''}`}
              style={{ flex: 1 }}
            >
              <div className={`hb-step-number-booking mx-auto mb-2 ${isActive ? 'active' : ''}`}>
                {isDone ? <i className="fas fa-check" /> : step.number}
              </div>
              <div className="hb-step-label-booking">{step.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BookingProgress;